import { twMerge } from 'tailwind-merge';
import cx from 'classnames';

// eslint-disable-next-line import/prefer-default-export
export function cn(...inputs: cx.ArgumentArray) {
  return twMerge(cx(inputs));
}

// eslint-disable-next-line import/prefer-default-export
export function atId(
  key: string,
  type:
    | 'Btn'
    | 'TxtArea'
    | 'Tgl'
    | 'ChkB'
    | 'Inp'
    | 'DtPicker'
    | 'Sel'
    | 'RadioBtn'
    | 'PopUp'
    | 'Box'
    | 'Link'
    | 'Img'
    | 'Val',
) {
  return `${key}_${type}`;
}

export function shuffleArray<T>(array: T[]): T[] {
  const newArray = [...array];
  // eslint-disable-next-line no-plusplus
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = newArray[i];
    newArray[i] = newArray[j];
    newArray[j] = temp;
  }

  return newArray;
}

export function getBirthdayDate(obj: { day?: string; month?: string; year?: string }): string {
  const { day, month, year } = obj;
  return day && month && year ? `${year}-${month}-${day}` : '';
}

export function addQueryParamToPath(key: string, value: string | null, replace = true) {
  const currentUrl = new URL(window.location.href);

  if (value) {
    currentUrl.searchParams.set(key, value);
  } else {
    currentUrl.searchParams.delete(key);
  }
  if (replace) {
    window.history.replaceState(null, '', currentUrl.toString());
  } else {
    window.history.pushState(null, '', currentUrl.toString());
  }
}

export function getQueryParam(key: string) {
  const currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get(key);
}
